import { render, staticRenderFns } from "./Standings.vue?vue&type=template&id=1726dbca&"
import script from "./Standings.vue?vue&type=script&lang=js&"
export * from "./Standings.vue?vue&type=script&lang=js&"
import style0 from "./Standings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports